'use strict';

/**This directive uses the salesCalculations service to give you access to the right values.
 * @param transactionProperties {transaction object} Supply the transaction object here.
 * @param tpConfig (optional) if a pos.config object is given, that will be used to calculate tpReceiptNr
 * @attrs tpTotalDiscount
 * @attrs tpTotal
 * @attrs tpCustomerName puts together the name of the customer.
 * @attrs tpReceiptNr
 * @attrs tpType {function} tpType(line) returns a string based on line.type
 * @attrs tpShowDiscount {function} returns true or false depending on the supplied line
 * @attrs tpDiscount
 * @attrs tpLineTotal
 */

// TODO refactor this 'directive' away
angular
  .module('posApp')
  .directive(
    'transactionProperties',
    (salesCalculations, utility, posInstance) => ({
      //template: '<div ng-transclude></div>',
      //transclude: true,
      //by setting it to true the child scope inherets, allowing it to search parent scope. {} will create isolate scope.
      scope: true,

      link: function ($scope, $element, $attrs) {
        let transaction;

        const calcReceiptNr = () => {
          if ($scope.transaction.nr) {
            $scope.tpReceiptNr = $scope.transaction.nr;
          } else if ($scope.tpConfig) {
            $scope.tpReceiptNr =
              $scope.tpConfig.cashregisterNr +
              '-' +
              posInstance.nr +
              '-' +
              $scope.tpConfig.receiptNr;
          }
        };

        //watch to see if a new object is assigned
        $scope.$watch($attrs.transactionProperties, () => {
          //"transactionProperties", function() {
          transaction = $scope.$parent.$eval($attrs.transactionProperties);
        });
        $scope.$watch($attrs.tpConfig, (model) => {
          $scope.tpConfig = $scope.$parent.$eval($attrs.tpConfig);
        });
        $scope.$watch(() => {
          //will need to recalculate this on every digest since any of the lines may have changed. Don't want to do the calc for every line though. Only once per digest.
          if (!transaction) {
            return;
          }
          $scope.tpTotalDiscount = salesCalculations.totalDiscount(transaction);
          $scope.tpTotal = salesCalculations.total(transaction);
          $scope.tpCustomerName = salesCalculations.customerName(transaction);
          if ($scope.transaction) {
            calcReceiptNr();
          }
        });

        $scope.tpType = (line) => salesCalculations.lineType(line);

        $scope.tpShowDiscount = (line) =>
          salesCalculations.showLineDiscount(transaction, line);

        $scope.tpDiscount = (line) =>
          salesCalculations.lineDiscount(transaction, line);

        $scope.tpLineTotal = (line) =>
          salesCalculations.lineTotal(transaction, line);

        $scope.tpChange = () => salesCalculations.changeAbsolute(transaction);

        $scope.tpToPay = () => {
          if (!transaction) {
            return;
          }

          let pay = salesCalculations.changeAbsolute(transaction);
          if (transaction.roundPayment) {
            pay = utility.roundTo5Cent(pay);
          }

          return pay;
        };

        $scope.tpBruto = (type) => {
          if (!transaction) {
            return;
          }
          if (!type) {
            return;
          }
          return salesCalculations.brutoAmount(transaction, type);
        };
        $scope.tpChangeText = () => salesCalculations.changeText(transaction);
      },
    }),
  );
